const low = (s) => String(s || '').toLowerCase();

// Everything typed on the user's open tickets (selections, players, teams) as one lowercase blob + player-name set.
export const ticketIndex = (parlays) => {
  const legs = (parlays || []).filter((p) => !p.archived).flatMap((p) => p.legs || []);
  const text = legs.map((l) => [l.selection, l.player_name, l.team, l.description].filter(Boolean).join(' ')).join(' | ').toLowerCase();
  return { text, players: new Set(legs.map((l) => low(l.player_name)).filter(Boolean)) };
};

export const gameOnTicket = (g, idx, players = []) => {
  if (!idx.text) return false;
  const teamHit = g.teams.some((t) => {
    const nickname = low(t.name).split(' ').pop();
    return idx.text.includes(low(t.name)) || (nickname.length > 3 && idx.text.includes(nickname)) || new RegExp(`\\b${low(t.abbr)}\\b`).test(idx.text);
  });
  return teamHit || players.some((p) => idx.text.includes(low(p.name)));
};

export const dayKey = (iso) => new Date(iso).toLocaleDateString('en-CA');
export const dayLabel = (iso) => {
  const k = dayKey(iso);
  if (k === dayKey(new Date().toISOString())) return 'Today';
  if (k === dayKey(new Date(Date.now() + 864e5).toISOString())) return 'Tomorrow';
  return new Date(iso).toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' });
};
